import api from './api';

/**
 * Service para cascade delete em 2 fases.
 * Fase 1 (getImpact): DELETE sem header → retorna preview de impacto (HTTP 200)
 * Fase 2 (confirmDelete): DELETE com header X-Cascade-Confirm → executa cascade (HTTP 204)
 */
const cascadeDeleteService = {
  /**
   * Fase 1: Obtém preview de impacto da exclusão.
   * @param {string} path - Caminho da API (ex: '/professionals/abc-123')
   * @returns {Promise<object>} DeleteImpactResponse
   */
  getImpact: async (path) => {
    const response = await api.delete(path);
    return response.data;
  },

  /**
   * Fase 2: Executa cascade delete com confirmação.
   * @param {string} path - Mesmo caminho da Fase 1
   * @param {string} confirmHash - Hash retornado na Fase 1
   * @returns {Promise<void>}
   */
  confirmDelete: async (path, confirmHash) => {
    await api.delete(path, {
      headers: { 'X-Cascade-Confirm': confirmHash },
    });
  },
};

export default cascadeDeleteService;
